"use client";
export default function CenterHeading({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-center gap-4 py-8">
      <div className="h-px bg-muted flex-grow"></div>
      <h2 className="text-lg text-muted-foreground font-josefin text-center whitespace-nowrap">
        {children}
      </h2>
      <div className="h-px bg-muted flex-grow"></div>
    </div>
  );
}
